import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import './AssessmentInfo.scss';

const AssessmentInfo = ({ fullName, surveyId, languageId }) => {
    return (
        <div className='assessment-info'>
            <div className='fl-header-survey-assessment'>
                { surveyId === 5 ? <span>{ i18n.t('engagement.engagement_survey') }</span>
                    : <span>{ i18n.t('app_container.motivator_assessment') }</span>
                }
            </div>
            { fullName && surveyId !== 5 && <div className='fl-header-survey-user-name'>
                <span>{languageId === 1 || languageId === 4 ? i18n.t('app_container.for') : null }{ fullName }{languageId === 3 ? i18n.t('app_container.for') : null }</span>
            </div> }
        </div>
    );
};

AssessmentInfo.propTypes = {
    fullName: PropTypes.string,
    languageId: PropTypes.number,
    surveyId: PropTypes.number
};

AssessmentInfo.defaultProps = {
    fullName: '',
    languageId: 1,
    surveyId: 1
};

export default AssessmentInfo;
